import type { HelpFile } from '../../types/help'
import { AccessProfileEditTestIds } from '../../../testids/AccessProfileEditTestIds'

export const accessProfileEditHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfileEditTestIds.accessProfileEditPage]:
      'Edit the name, description, code, and risk metadata of this access profile.',
  },
}
